export default __webpack_public_path__ + "static/media/lamp.1177c742.svg";